export default "__VITE_ASSET__B_ypDR0y__"